import React from "react";
import styled from "styled-components";
import { textStyle } from "../../dimensions";
import { getBackgroundColor, statusesWithWayfinding } from "../TicketCardv2";
var SeatInfov2 = function SeatInfov2(_ref) {
  var seat = _ref.seat,
    section = _ref.section,
    row = _ref.row,
    type = _ref.type,
    wayfindingColors = _ref.wayfindingColors;
  return /*#__PURE__*/React.createElement(RowList, {
    $type: type,
    $wayfindingColors: wayfindingColors
  }, /*#__PURE__*/React.createElement(RowItem, {
    $slot: "start"
  }, /*#__PURE__*/React.createElement(LocationLabel, {
    $type: type,
    $wayfindingColors: wayfindingColors
  }, section !== null && section !== void 0 && section.value ? section.title : ""), /*#__PURE__*/React.createElement(LocationDescription, {
    $type: type,
    $wayfindingColors: wayfindingColors,
    $slot: "start",
    translate: "no"
  }, section !== null && section !== void 0 && section.value ? section.value : "")), /*#__PURE__*/React.createElement(RowItem, {
    $slot: "middle"
  }, /*#__PURE__*/React.createElement(LocationLabel, {
    $type: type,
    $wayfindingColors: wayfindingColors
  }, row !== null && row !== void 0 && row.value ? row.title : ""), /*#__PURE__*/React.createElement(LocationDescription, {
    $type: type,
    $wayfindingColors: wayfindingColors,
    $slot: "middle",
    translate: "no"
  }, row !== null && row !== void 0 && row.value ? row.value : "")), /*#__PURE__*/React.createElement(RowItem, {
    $slot: "end"
  }, /*#__PURE__*/React.createElement(LocationLabel, {
    $type: type,
    $wayfindingColors: wayfindingColors
  }, seat !== null && seat !== void 0 && seat.value ? seat.title : ""), /*#__PURE__*/React.createElement(LocationDescription, {
    $type: type,
    $wayfindingColors: wayfindingColors,
    $slot: "end",
    translate: "no"
  }, seat !== null && seat !== void 0 && seat.value ? seat.value : "")));
};
export var getTextColor = function getTextColor(theme, type, wayfinding, location) {
  if (!type) return theme.text.primary;
  if (wayfinding && statusesWithWayfinding.includes(type)) {
    var foreground = wayfinding.foreground;
    return foreground;
  } else if (location === "title") {
    return theme.text.secondary;
  } else {
    var overrideColors = {
      disabled: "secondary",
      membership: undefined,
      primary: undefined,
      resale: "secondary",
      reserved: undefined,
      transfer: "secondary",
      upsell: undefined,
      addedValue: undefined
    };
    var overrideColor = overrideColors[type];
    return overrideColor ? theme.text.secondary : theme.text.primary;
  }
};
var RowList = styled.dl.withConfig({
  displayName: "SeatInfov2__RowList",
  componentId: "sc-hzxzxj-0"
})(["display:flex;justify-content:space-between;margin:0;background-color:", ";"], function (_ref2) {
  var $type = _ref2.$type,
    $wayfindingColors = _ref2.$wayfindingColors;
  return getBackgroundColor($type, $wayfindingColors);
});
var RowItem = styled.div.withConfig({
  displayName: "SeatInfov2__RowItem",
  componentId: "sc-hzxzxj-1"
})(["display:grid;grid-row-gap:2px;grid-template-rows:repeat(2,min-content);justify-items:", ";"], function (_ref3) {
  var $slot = _ref3.$slot;
  switch ($slot) {
    case "start":
      return "flex-start";
    case "middle":
      return "center";
    case "end":
      return "flex-end";
    default:
      return "flex-start";
  }
});
var LocationLabel = styled.dt.withConfig({
  displayName: "SeatInfov2__LocationLabel",
  componentId: "sc-hzxzxj-2"
})(["width:fit-content;margin:0px;color:", ";", " text-align:center;text-transform:uppercase;"], function (_ref4) {
  var theme = _ref4.theme,
    $type = _ref4.$type,
    $wayfindingColors = _ref4.$wayfindingColors;
  return getTextColor(theme, $type, $wayfindingColors, "title");
}, textStyle.nevis);
var LocationDescription = styled.dd.withConfig({
  displayName: "SeatInfov2__LocationDescription",
  componentId: "sc-hzxzxj-3"
})(["width:100%;margin:0px;overflow:hidden;color:", ";", " text-align:", ";word-wrap:break-word;overflow-wrap:break-word;"], function (_ref5) {
  var theme = _ref5.theme,
    $type = _ref5.$type,
    $wayfindingColors = _ref5.$wayfindingColors;
  return getTextColor(theme, $type, $wayfindingColors);
}, textStyle.vinson, function (_ref6) {
  var $slot = _ref6.$slot;
  switch ($slot) {
    case "start":
      return "left";
    case "middle":
      return "center";
    case "end":
      return "right";
    default:
      return "left";
  }
});
export default SeatInfov2;